import React, { memo, useMemo, lazy, Suspense, useEffect} from 'react'
import { Loading } from 'components/shared'
import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import { 
	LAYOUT_TYPE_CLASSIC, 
	LAYOUT_TYPE_MODERN, 
	LAYOUT_TYPE_SIMPLE,
	LAYOUT_TYPE_STACKED_SIDE,
	LAYOUT_TYPE_DECKED,
	LAYOUT_TYPE_BLANK
} from 'constants/theme.constant'
import useAuth from 'utils/hooks/useAuth'
import useDirection from 'utils/hooks/useDirection'
import useLocale from 'utils/hooks/useLocale'

const layouts = {
	[LAYOUT_TYPE_CLASSIC]: lazy(() => import('./ClassicLayout')),
	[LAYOUT_TYPE_MODERN]: lazy(() => import('./ModernLayout')),
	[LAYOUT_TYPE_STACKED_SIDE]: lazy(() => import('./StackedSideLayout')),
	[LAYOUT_TYPE_SIMPLE]: lazy(() => import('./SimpleLayout')),
	[LAYOUT_TYPE_DECKED]: lazy(() => import('./DeckedLayout')),
	[LAYOUT_TYPE_BLANK]: lazy(() => import('./BlankLayout')),
}

const Layout = () => {
	const dispatch = useDispatch()
	const [searchParams] = useSearchParams();
	let currentParams = null;
	if (searchParams) {
		currentParams = Object.fromEntries([...searchParams]);
	}
	const themeLayout = useSelector((state) => state.theme.layout.type);
	const layoutType = currentParams.useLayout === 'blank'?  LAYOUT_TYPE_BLANK : themeLayout;

	const { authenticated } = useAuth()

	useDirection()

	useLocale()

	const partner = useSelector(state => state.auth.partner)

	useEffect(() => {
		const short = partner?.shortName || 'partner-web'
		document.title = `EywaFarm - ${short}`
		const logoUrl = partner?.logo?.url || '/img/logo/eywa-farm-logo_HighRes.png'
		const link = document.querySelector('link[rel="icon"]') || document.createElement('link')
		link.rel = 'icon'
		const ext = (logoUrl || '').split('.').pop().split('?')[0].toLowerCase()
		let type = 'image/png'
		if (ext === 'ico') type = 'image/x-icon'
		else if (ext === 'svg') type = 'image/svg+xml'
		else if (ext === 'jpg' || ext === 'jpeg') type = 'image/jpeg'
		link.type = type
		link.href = logoUrl
		document.head.appendChild(link)
	}, [partner?.shortName, partner?.logo?.url])

	const AppLayout = useMemo(() => {
		if (authenticated) {
			return layouts[layoutType]
		}
		return lazy(() => import('./AuthLayout'))
	}, [layoutType, authenticated])

	return (
		<Suspense 
			fallback={
				<div className="flex flex-auto flex-col h-[100vh]">
					<Loading loading={true} />
				</div>
			}
		>
			<AppLayout />
		</Suspense>
	)
}

export default memo(Layout)
